import React from 'react'
import { TimeStatus, TimeStatusLabel } from '../../enums/time-status-new';

interface TimeStatusBadgeProps {
    timeStatus: TimeStatus;
}

const TimeStatusBadge: React.FC<TimeStatusBadgeProps> = ({ ...props }) => {

    const defaultBadgeClasses = 'text-white px-4 py-2 rounded-full text-center';

    switch (props.timeStatus) {
        case TimeStatus.ON_TIME:
            return (
                <div className={`bg-green-500 ${defaultBadgeClasses}`}>
                    {TimeStatusLabel.ON_TIME}
                </div>
            )
        case TimeStatus.DEPARTED:
            return (
                <div className={`bg-red-400 ${defaultBadgeClasses}`}>
                    {TimeStatusLabel.DEPARTED}
                </div>
            )
        case TimeStatus.ONBOARDING:
            return (
                <div className={`bg-yellow-500 ${defaultBadgeClasses}`}>
                    {TimeStatusLabel.ONBOARDING}
                </div>
            )
        case TimeStatus.DELAY:
            return (
                <div className={`bg-red-500 ${defaultBadgeClasses}`}>
                    {TimeStatusLabel.DELAY}
                </div>
            )
        case TimeStatus.CANCELLED:
            return (
                <div className={`bg-red-500 ${defaultBadgeClasses}`}>
                    {TimeStatusLabel.CANCELLED}
                </div>
            )
        default:
            return (
                <div className={`bg-green-500 ${defaultBadgeClasses}`}>
                    {TimeStatusLabel.ON_TIME}
                </div>
            )
    }
}

export default TimeStatusBadge;